var React = require('react');

function ChevronSolidUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.5 0.5L0 4H7L3.5 0.5Z","fill":"#929088"}));
}

ChevronSolidUp.defaultProps = {"width":"7","height":"4","viewBox":"0 0 7 4","fill":"none"};

module.exports = ChevronSolidUp;

ChevronSolidUp.default = ChevronSolidUp;
